import {gql} from '@apollo/client'
export const queryAPIPullTotal=gql`
query OpenAPIPullTotal {
  openAPIPullTotal {
    part
    total
  }
}
`
export const queryAPIPushTotal=gql`
query OpenAPIPushTotal {
  openAPIPushTotal {
    part
    total
  }
}
`
export const queryAPIPubSubTotal=gql`
query OpenAPIPubSubTotal {
  openAPIPubSubTotal {
    part
    total
  }
}
`
export const queryAPIAppTotal=gql`
query Query{
    openAPIAppTotal
}
`
export const queryAPIDeveloperTotal=gql`
query Query{
    openAPIDeveloperTotal
}
`
export const queryAPIBindUserTotal=gql`
query OpenAPIBindUserTotal {
  openAPIBindUserTotal {
    part
    total
  }
}
`
export const queryAPIAppCountByDate=gql`
query Query($startDate: Date!, $endDate: Date!) {
    openAPIAppCountByDate(startDate: $startDate, endDate: $endDate) {
      year
      month
      count
    }
  }
`

export const queryAPIDeveloperCountByDate=gql`
query OpenAPIDeveloperCountByDate($startDate: Date!, $endDate: Date!) {
  openAPIDeveloperCountByDate(startDate: $startDate, endDate: $endDate) {
    year
    month
    count
  }
}
`
export const queryAPIBindUserCountByDate=gql`
query Query($startDate: Date!, $endDate: Date!) {
    openAPIBindUserCountByDate(startDate: $startDate, endDate: $endDate) {
      year
      month
      count
    }
  }
`
export const queryAPIPullCountByMonths=gql`
query OpenAPIPullCountByMonths($start: String!, $end: String!) {
  openAPIPullCountByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`
export const queryAPIPushCountByMonths=gql`
query OpenAPIPushCountByMonths($start: String!, $end: String!) {
  openAPIPushCountByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`
export const queryAPIPubSubCountByMonths=gql`
query OpenAPIPubSubCountByMonths($start: String!, $end: String!) {
  openAPIPubSubCountByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`
export const OpenAPIAppList=gql`
query OpenAPIAppList($page: Int!, $count: Int!, $isPermanent: Boolean, $name: String) {
  openAPIAppList(page: $page, count: $count, isPermanent: $isPermanent, name: $name) {
    data {
      trialTime
      state
      solutions
      organization
      lastChangeTime
      expiredTime
      clientId
      client
      appName
    }
    total
  }
}
`
export const queryOpenAPIPermanentBindUserCountByDate=gql`
query OpenAPIPermanentBindUserCountByDate($startDate: Date!, $endDate: Date!) {
  openAPIPermanentBindUserCountByDate(startDate: $startDate, endDate: $endDate) {
    year
    month
    count
  }
}
`
export const queryOpenAPIPermanentPullCountByMonths=gql`
query OpenAPIPermanentPullCountByMonths($start: String!, $end: String!) {
  openAPIPermanentPullCountByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`
export const queryOpenAPIPermanentPushCountByMonths=gql`
query OpenAPIPermanentPushCountByMonths($start: String!, $end: String!) {
  openAPIPermanentPushCountByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`
export const queryOpenAPIPermanentPubsubByMonths=gql`
query OpenAPIPermanentPubsubByMonths($start: String!, $end: String!) {
  openAPIPermanentPubsubByMonths(start: $start, end: $end) {
    year
    month
    count
  }
}
`